export const Input = {
    // The styles all inputs have in common
    baseStyle: {
        background: 'transparent',
        border: 'none',
        cursor: 'pointer',
        fontFamily: 'inherit',
        fontSize: '100%',
        lineHeight: '1.15',
        margin: '0',
        padding: '0',
        color: 'inherit',
    },
};
